import { useTranslation } from 'react-i18next'
import { Link as RouterLink } from 'react-router-dom'

import { Box, Button, Stack } from '@mui/material'

import CheckCircle from '@mui/icons-material/CheckCircle'

import responsiveHook from '@hooks/useResponsive'

import { TLGTypography } from '@components/TLGTypography'

import { scaleUpTransition } from '@utils/styles'

import {
  containerSx,
  getStartedForFreeButtonSx,
  heroImageBrightnessSx,
  heroImageSx,
  heroLeftSideContentSx,
  heroLeftSideWrapperSx,
  heroRightSideWrapperSx,
  heroSubtitleSx,
  heroTitleSx,
  mobileOrTabletCertificationCardsContainerSx,
} from './styles'

import { CertificationCards } from './components/CertificationCards'

const HeroSection = () => {
  const { t } = useTranslation()

  const { isMobileOrTablet, isDesktop, ifDesktop } =
    responsiveHook.useResponsive()

  return (
    <Box data-testid="home-hero-section" sx={containerSx}>
      <Stack sx={heroLeftSideWrapperSx}>
        <Stack sx={heroLeftSideContentSx}>
          <TLGTypography
            component="h1"
            responsiveVariant={{
              xs: 'h5',
              md: 'h4',
              lg: 'h3',
            }}
            sx={heroTitleSx}
          >
            {t('Find your perfect tech partner match, effortlessly')}
          </TLGTypography>
          <TLGTypography
            responsiveVariant={{ xs: 'subtitle1', md: 'h6' }}
            component="h2"
            sx={heroSubtitleSx}
          >
            {t(
              'Revolutionize how you discover & connect with tech partners. Access emerging tech. No more unsolicited sales calls or irrelevant tech options. Join the ranks of forward-thinking leaders & experience tech matchmaking.'
            )}
          </TLGTypography>

          <Button
            data-testid="hero-get-started-for-free-button"
            component={RouterLink}
            to="/signup"
            variant="contained"
            color="secondary"
            size="medium"
            endIcon={<CheckCircle />}
            sx={getStartedForFreeButtonSx}
          >
            {t('Get Started for Free Now')}
          </Button>

          {isMobileOrTablet && (
            <CertificationCards
              containerSx={mobileOrTabletCertificationCardsContainerSx}
            />
          )}
        </Stack>

        <Stack sx={heroRightSideWrapperSx}>
          <Box sx={heroImageBrightnessSx} />

          <Box
            alt={t('Vendor Dashboard')}
            loading="lazy"
            component="img"
            src="/images/buyer-dashboard-hero.webp"
            sx={{ ...heroImageSx, ...ifDesktop(scaleUpTransition) }}
          />

          {isDesktop && <CertificationCards />}
        </Stack>
      </Stack>
    </Box>
  )
}

export { HeroSection }
